import { combineReducers } from 'redux';
import NotificationStore from '../Notification/reducers';
import UserStore from '../User/reducers';
import { componentReducer } from '../components/reducers';
import { authReducer } from '../Auth/reducer';
import LotStore from '../Lots/reducers';
import BuilderStore from '../Builders/reducers';
import {ProjectStore, PhaseStore} from '../Projects/reducers';
import RegionMarketStore from '../Region-Market/reducers';
import RFSStore from '../Request-Services/reducers';
import SettingStore from '../Setting/reducers';
import RequestTypeStore from '../Request-Types/reducers';
import RoomStore from '../Rooms/reducers';
import WorkOrderReducer from '../Work-Orders/reducers';
import { SubcontractorStore } from '../Subcontractors/reducers';
import TradeStore from '../Trades/reducers';
import ItemRepairStore from '../Items/reducers';
import WorkOrderTypesStore from '../Work-Order-Type/reducers';
import PurchaseOrderStore from '../Purchase-Orders/reducers';
import {i18nState} from 'redux-i18n';
import HomeCareStore from '../HomeCare/reducers';

const rootReducer = combineReducers({
  UserStore,
  NotificationStore,
  componentReducer,
  authReducer,
  LotStore,
  BuilderStore,
  SettingStore,
  ProjectStore,
  PhaseStore,
  RegionMarketStore,
  RFSStore,
  RequestTypeStore,
  RoomStore,
  WorkOrderReducer,
  SubcontractorStore,
  TradeStore,
  ItemRepairStore,
  WorkOrderTypesStore,
  PurchaseOrderStore,
  i18nState,
  HomeCareStore
});

export default rootReducer;




// WEBPACK FOOTER //
// ./src/portal_homeowner/reducer.js